export type ParsedUserAgent = {
  browser?: string;
  os?: string;
};

// Order matters: the browsers above Chrome also claim to be Chrome, and Chrome claims Safari.
const BROWSERS: [RegExp, string][] = [
  [/Edg(e|A|iOS)?\//, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/SamsungBrowser\//, "Samsung Internet"],
  [/DuckDuckGo\//, "DuckDuckGo"],
  [/Silk\//, "Amazon Silk"],
  [/Firefox\/|FxiOS\//, "Firefox"],
  [/Chrome\/|CriOS\//, "Chrome"],
  [/Version\/[\d.]+.*Safari\//, "Safari"],
];

// iOS before macOS (iPads can say "like Mac OS X"), Android before Linux.
const OPERATING_SYSTEMS: [RegExp, string][] = [
  [/Windows/, "Windows"],
  [/iPhone|iPad|iPod/, "iOS"],
  [/Android/, "Android"],
  [/CrOS/, "ChromeOS"],
  [/Mac OS X|Macintosh/, "macOS"],
  [/Linux/, "Linux"],
];

function firstMatch(userAgent: string, patterns: [RegExp, string][]): string | undefined {
  return patterns.find(([pattern]) => pattern.test(userAgent))?.[1];
}

/** Picks the browser and OS out of a user-agent string. Good enough to label a device, no more. */
export function parseUserAgent(userAgent: string | null | undefined): ParsedUserAgent {
  if (!userAgent) return {};
  return {
    browser: firstMatch(userAgent, BROWSERS),
    os: firstMatch(userAgent, OPERATING_SYSTEMS),
  };
}

/** e.g. "Chrome on macOS", falling back to whichever half is known. */
export function describeUserAgent(userAgent: string | null | undefined): string {
  const { browser, os } = parseUserAgent(userAgent);
  if (browser && os) return `${browser} on ${os}`;
  return browser ?? os ?? "Unknown device";
}
